import { HTTPService, type HTTPRequestConfig } from ".";

export class FetchHttpService extends HTTPService<Response> {
	encodeBody(data: Record<string, any> | FormData | null, config: HTTPRequestConfig): void {
		if (data instanceof FormData) {
			config.body = data;
		} else {
			config.body = JSON.stringify(data);
			config.headers["Content-Type"] = "application/json";
		}
	}

	async executeHTTPCall(url: string, config: HTTPRequestConfig): Promise<Response> {
		const controller = new AbortController();
		const timeoutId = setTimeout(() => controller.abort(), config.timeout ?? 30 * 1_000);

		const response = await fetch(url, { ...config, signal: controller.signal });
		clearTimeout(timeoutId);

		return response;
	}

	async parseBody<T>(response: Response): Promise<T> {
		let data: T;

		const contentType = response.headers.get("content-type") || "";
		if (/json/.test(contentType)) {
			data = (await response.json()) as T;
		} else if (/image/.test(contentType)) {
			data = (await response.blob()) as T;
		} else {
			data = (await response.text()) as any;
		}

		return data;
	}
}
